module.exports = __webpack_public_path__ + "static/media/che9.f24a28d2.png";